import { useEffect, useState } from 'react'
import { isStandalone } from './platform'

/** true inside the installed app (home-screen / app-window launch). false on the server and in a browser tab. */
export function useIsStandalone(): boolean {
  const [on, setOn] = useState(false)
  useEffect(() => {
    setOn(isStandalone(window))
    const mq = window.matchMedia?.('(display-mode: standalone)')
    const update = () => setOn(isStandalone(window))
    mq?.addEventListener?.('change', update)
    return () => mq?.removeEventListener?.('change', update)
  }, [])
  return on
}
